/**
 * Recursively converts BigInt values to strings so query keys are JSON-serializable.
 * Protobuf Timestamp objects have BigInt `seconds` fields that break JSON.stringify.
 */
function safeKey(params: Record<string, unknown> | undefined): Record<string, unknown> | undefined {
  if (!params) return undefined;
  return JSON.parse(JSON.stringify(params, (_key, value) =>
    typeof value === "bigint" ? value.toString() : value
  ));
}

export const queryKeys = {
  categories: {
    all: () => ["categories"] as const,
    detail: (id: number) => ["categories", id] as const,
  },
  tags: {
    all: () => ["tags"] as const,
    detail: (id: number) => ["tags", id] as const,
  },
  exercises: {
    all: () => ["exercises"] as const,
    list: (filters?: Record<string, unknown>) =>
      ["exercises", "list", safeKey(filters)] as const,
    detail: (id: number) => ["exercises", id] as const,
    stats: (id: number) => ["exercises", id, "stats"] as const,
    variations: (parentId: number) =>
      ["exercises", parentId, "variations"] as const,
  },
  sessions: {
    all: () => ["sessions"] as const,
    list: (filters?: Record<string, unknown>) =>
      ["sessions", "list", safeKey(filters)] as const,
    detail: (id: number) => ["sessions", id] as const,
    active: () => ["sessions", "active"] as const,
    stats: (params?: Record<string, unknown>) =>
      ["sessions", "stats", safeKey(params)] as const,
  },
  history: {
    all: () => ["history"] as const,
    list: (filters?: Record<string, unknown>) =>
      ["history", "list", safeKey(filters)] as const,
    detail: (id: number) => ["history", id] as const,
  },
  stats: {
    practice: (params?: Record<string, unknown>) =>
      ["stats", "practice", safeKey(params)] as const,
    exercise: (id: number, params?: Record<string, unknown>) =>
      ["stats", "exercise", id, safeKey(params)] as const,
  },
  newBreed: {
    systems: () => ["newBreed", "systems"] as const,
    melodyPages: () => ["newBreed", "melodyPages"] as const,
    matrix: (params?: Record<string, unknown>) =>
      ["newBreed", "matrix", safeKey(params)] as const,
    systemProgress: (systemId: number, params?: Record<string, unknown>) =>
      ["newBreed", "systemProgress", systemId, safeKey(params)] as const,
    entries: (filters?: Record<string, unknown>) =>
      ["newBreed", "entries", safeKey(filters)] as const,
  },
  settings: {
    all: () => ["settings"] as const,
  },
};
